"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sizes = {
    container: {
        xs: '375px',
        sm: '780px',
        md: '1200px',
        lg: '1440px',
        xl: '1920px',
    },
};
exports.default = sizes;
